import {Box, Container, Stack, Typography} from '@mui/material';
import * as React from 'react';
import FooterItemList from './FooterItemList';
import {useAuthentication} from '../auth/hooks/useAuthentication';
import {useDarkMode} from '../darkMode/hook/useDarkMode';

const Footer = ({logo}) => {
  const {isAuthenticated, isLoading} = useAuthentication();
  const {mode, darkMode} = useDarkMode();

  return (
      !isLoading && <footer style={{backgroundColor: 'transparent'}}>
      <Box
        sx={{
          backgroundColor: {
            xs: mode.settings.footerBackgroundColor,
            md: mode.settings.footerBackgroundColor,
            lg: mode.darkMode
              ? mode.settings.backgroundColor
              : isAuthenticated
              ? '#F0F2F8'
              : '#FFFFFF',
          },
          backgroundImage: {
            xs: 'none',
            md: 'none',
            lg: mode.settings.footerWave,
          },
          backgroundRepeat: 'round',
          height: 'auto',
          color: '#FFFFFF',
          padding: 5,
          paddingBottom: '100px',
          backgroundSize: 'cover',
        }}>
        <Container style={{height: 'auto'}}>
          <Stack
            direction={'row'}
            alignItems={'center'}
            spacing={3}
            justifyContent={{xs : 'center', md: 'space-between', lg: 'space-between'}}
            style={{marginTop: 70}}
            flexWrap={'wrap'}
            gap={{xs : '20px', md: '20px', lg: '0px'}}>
            <Stack
              direction={'column'}
              spacing={2}
              alignItems={'center'}
              justifyContent={'center'}>
              <img
                src={`/assets/img/logo-ohs-blanc.png`}
                alt="Logo OHS"
                style={{width: 194, height: 78}}
              />
              <Stack direction={'row'} alignItems={'center'}>
                <a href="https://www.linkedin.com/company/ohs-de-lorraine/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
                    <img
                      src={`/assets/img/linkedin.png`}
                      alt="Linkedin"
                      style={{width: 34, height: 34, marginRight: 10}}
                    />
                  </a>
                <img src={`/assets/img/youtube.png`} alt="Youtube" />
              </Stack>
            </Stack>
            {isAuthenticated && (
              <FooterItemList
                title={'MON COMPTE'}
                item={[
                  ['Mon compte', '/profile'],
                  ['Mon abonnement', '/subscription-choice'],
                ]}
              />
            )}
            <FooterItemList
              title={'NOUS CONNAITRE'}
              item={[
                ['OHS Solutions', '/#text'],
                ['Nos services', '/#service'],
                ["L'OHS de Lorraine", '/#text_lorraine'],
              ]}
            />
            <FooterItemList
              title={'TRAVAILLER AVEC NOUS'}
              item={[
                ['Devenir partenaire de OHS Solutions', '/#'],
                ['OHS Solutions pour votre entreprise', '/#'],
                [
                  "Offres d'emploi de l'OHS de Lorraine",
                  'https://taleez.com/careers/ohs-recrutement',
                ],
              ]}
            />
            <FooterItemList
              title={'PROFESSIONNEL DE SANTE'}
              item={[
                ['Nos activités', '/#'],
                ['Nos établissements', '/#'],
                [
                  'Orienter un patient',
                  'https://trajectoire.sante-ra.fr/Trajectoire/',
                ],
              ]}
            />
            <FooterItemList
              title={'BESOIN D’AIDE'}
              item={[
                ['Questions fréquentes', '/#'],
                ['Contactez-nous', '/#'],
                ['Accessibilité', '/#'],
              ]}
            />
          </Stack>
        </Container>
      </Box>
      <Box
        height={'auto'}
        style={{
          backgroundColor: mode.settings.footerBackgroundColor,
          minHeight: 70,
          minWidth: '360px',
        }}>
        <Container>
            <Stack
                direction={'row'}
                justifyContent={'space-around'}
                flexWrap={'wrap'}>
                <Typography
                    className={'footer_item'}
                    variant={'subtitle8'}
                    color={'white'}>
                    EN SAVOIR PLUS
                </Typography>
                <a href="/assets/files/20250519 - CGS OHS Solutions.pdf" download
                   style={{textDecoration: 'none', marginTop: '21px'}}>
                    <Typography
                        className={'footer_item'}
                        variant={'subtitle9'}
                        color={'white'}>
                        Conditions Générales de Ventes
                    </Typography>
                </a>
                <img
                    className={'footer_separator'}
                    src={`/assets/img/rectangle.png`}
                    alt="rectangle"
                />
                <a href="/assets/files/20250519 - CGU OHS Solutions.pdf" download
                   style={{textDecoration: 'none', marginTop: '21px'}}>
                    <Typography
                        className={'footer_item'}
                        variant={'subtitle9'}
                        color={'white'}>
                        Conditions Générales d’Utilisations
                    </Typography>
                </a>
                <img
                    className={'footer_separator'}
                    src={`/assets/img/rectangle.png`}
                    alt="rectangle"
                />
                <a href="/assets/files/20250519 - Politique de moderation OHS Solutions.pdf" download
                   style={{textDecoration: 'none', marginTop: '21px'}}>
                    <Typography
                        className={'footer_item'}
                        variant={'subtitle9'}
                        color={'white'}>
                        Politique de modération
                    </Typography>
                </a>
                <img
                    className={'footer_separator'}
                    src={`/assets/img/rectangle.png`}
                    alt="rectangle"
                />
                <a href="/assets/files/20250519 - Mentions légales OHS Solutions.pdf" download
                   style={{textDecoration: 'none', marginTop: '21px'}}>
                    <Typography
                        className={'footer_item'}
                        variant={'subtitle9'}
                        color={'white'}>
                        Mentions légales
                    </Typography>
                </a>


            </Stack>
        </Container>
      </Box>
      </footer>
  );
};

export default Footer;
